import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EmailConfigurationForm } from '../../../types/email/EmailTypes';

interface EmailConfigState {
  form: EmailConfigurationForm;
  testEmail: string;
  isLoading: boolean;
  isSubmitting: boolean;
  isTesting: boolean;
  error: string | null;
}

const initialForm: EmailConfigurationForm = {
  id: null,
  provider: '',
  smtpHost: '',
  smtpPort: null,
  username: '',
  password: '',
  fromName: '',
  fromEmail: '',
  authEnabled: true,
  tlsEnabled: true,
  active: false,
};

const initialState: EmailConfigState = {
  form: initialForm,
  testEmail: '',
  isLoading: false,
  isSubmitting: false,
  isTesting: false,
  error: null,
};

const emailConfigSlice = createSlice({
  name: 'emailConfig',
  initialState,
  reducers: {
    setEmailLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setEmailSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },
    setEmailTesting(state, action: PayloadAction<boolean>) {
      state.isTesting = action.payload;
    },
    setEmailError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setEmailConfig(state, action: PayloadAction<EmailConfigurationForm>) {
      state.form = {
        ...initialForm,
        ...action.payload,
        smtpPort: action.payload.smtpPort ?? null,
        authEnabled: Boolean(action.payload.authEnabled),
        tlsEnabled: Boolean(action.payload.tlsEnabled),
        active: Boolean(action.payload.active),
      };
      state.error = null;
    },
    updateEmailField(
      state,
      action: PayloadAction<{ field: keyof EmailConfigurationForm; value: any }>
    ) {
      const { field, value } = action.payload;
      state.form = {
        ...state.form,
        [field]: value,
      };
    },
    setEmailTestRecipient(state, action: PayloadAction<string>) {
      state.testEmail = action.payload;
    },
    resetEmailConfig(state) {
      state.form = initialForm;
      state.testEmail = '';
      state.isSubmitting = false;
      state.isTesting = false;
      state.error = null;
    },
  },
});

export const {
  setEmailLoading,
  setEmailSubmitting,
  setEmailTesting,
  setEmailError,
  setEmailConfig,
  updateEmailField,
  setEmailTestRecipient,
  resetEmailConfig,
} = emailConfigSlice.actions;

export default emailConfigSlice.reducer;
